import React from 'react';
import CardSection from '~/components/shared/CardSection/CardSection';
import { SvgSrc } from '~/components/shared/Icon/Icon';
import Slider from '~/components/shared/Slider/Slider';
import useTranslate from '~/hooks/useTranslate';

interface Props {
  loanPeriod: number;
  minTerm: number;
  maxAllowedTerm: number;
  onTermsSliderChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  sliderStep?: number;
}

const TermsSlider: React.FC<Props> = ({
  loanPeriod,
  minTerm,
  maxAllowedTerm,
  onTermsSliderChange,
  sliderStep = 1,
}) => {
  const translate = useTranslate();
  const shouldMaxTermLogicApplies = false;

  const explanation = shouldMaxTermLogicApplies
    ? (translate('LoanConfigurationCard.ChooseTermExplanation') as string)
    : '';

  return (
    <CardSection
      title={translate('LoanConfigurationCard.LoanPeriod') as string}
      value={`${loanPeriod ?? minTerm} ${translate('Months') as string}`}
      iconSrc={SvgSrc.Calendar}
      explanation={explanation}
    >
      <Slider
        name="loanPeriod"
        min={minTerm}
        max={maxAllowedTerm}
        step={sliderStep}
        value={loanPeriod ?? maxAllowedTerm}
        onChange={onTermsSliderChange}
        minDescription={`${translate(
          'LoanConfigurationCard.TermsMin'
        )}: ${minTerm} ${translate('Months')}`}
        maxDescription={`${translate(
          'LoanConfigurationCard.TermsMax'
        )}: ${maxAllowedTerm} ${translate('Months')}`}
      />
    </CardSection>
  );
};

export default TermsSlider;
